// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"b0da16f7","580":"56842820"}[chunkId] + ".chunk.js";
};